/**
 * Number of distinct promo campaigns behind a promo-view analytics table.
 *
 * A promo product can hold several tiers and the table lists one row per
 * tier, so a plain row count would report a three-tier promo as three promos.
 * Rows are grouped by product; a legacy ungrouped package (null product_id)
 * is its own campaign, keyed by its package id. A row with NO product_id at
 * all (an admin build running ahead of the server that added the field) is
 * keyed the same way, so the count degrades to one-per-tier instead of
 * collapsing every row into a single "product-undefined" campaign.
 */
export const countPromoProducts = (
  rows: { product_id: string | null; package_id: number; promo_active: boolean }[],
  options: { activeOnly?: boolean } = {},
): number =>
  new Set(
    rows
      .filter((row) => !options.activeOnly || row.promo_active)
      .map((row) => (row.product_id ? `product-${row.product_id}` : `package-${row.package_id}`)),
  ).size;
